interface IProps {
  placement?: 'top' | 'bottom';
}

const LinearArrowUpIcon = ({ placement = 'top' }: IProps) => {
  const obj = {
    top: '0',
    bottom: '180deg'
  };

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: `rotate(${obj[placement]})` }}>
      <path d="M12.0465 6.37967L7.99979 2.33301L3.95312 6.37967" stroke="currentColor" strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 13.6663V2.44629" stroke="currentColor" strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default LinearArrowUpIcon;
